import { useEffect, useState } from 'react';
import { Button, Col, Container, Row, Table } from 'react-bootstrap';

import { FileEarmark, GraphUpArrow, PencilSquare } from 'react-bootstrap-icons';
import CustomerInvestmentModal from './customer-investment-modal';
import { InvestmentProps } from './investment.types';
import { getFile } from '../../../utils/commons.utils';
import FileViewerModal from '../../../components/file-viewer-modal';

interface CustomerInvestmentsProps {
  investments: any;
  userId: string;
}

const CustomerInvestments: React.FC<CustomerInvestmentsProps> = ({ investments, userId }) => {
  const [isInvestmentModalOpen, setIsInvestmentModalOpen] = useState(false);
  const [investmentSelected, setInvestmentSelected] = useState<InvestmentProps | null>(null);
  const [investmentsData, setInvestmentsData] = useState<any[]>([]);
  const [isDocumentModalOpen, setIsDocumentModalOpen] = useState(false);
  const [fileBlob, setFileBlob] = useState();

  useEffect(() => {
    if (investments && investments.length) setInvestmentsData(investments);
  }, [investments]);

  const handleSuccess = (response: any) => {
    if (response.id) {
      const investmentExists = investmentsData.some((investment) => investment.id === response.id);
      if (investmentExists) {
        const updatedInvestments = investmentsData.map((investment) => {
          if (investment.id === response.id) {
            return response;
          }
          return investment;
        });
        setInvestmentsData(updatedInvestments);
      } else {
        setInvestmentsData([...investmentsData, response]);
      }
    }
    setIsInvestmentModalOpen(false);
  };

  const handleEditClick = (investmentId: string) => {
    const investment = investmentsData.find((inv) => inv.id === investmentId);
    setInvestmentSelected(investment);
    setIsInvestmentModalOpen(true);
  };

  const handleCreateNew = () => {
    setInvestmentSelected(null);
    setIsInvestmentModalOpen(true);
  };

  const handleOpenDocument = async (
    fileUrl: string,
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
  ) => {
    e.preventDefault();
    const file = await getFile(fileUrl);
    if (file) {
      setFileBlob(file);
      setIsDocumentModalOpen(true);
    }
  };

  const renderInvestments = () => {
    if (!investmentsData || investmentsData.length === 0) {
      return (
        <tr>
          <td className="text-center" colSpan={4}>
            No hay inversiones
          </td>
        </tr>
      );
    }
    return investmentsData.map((investment: any) => {
      let fileUrl = null;
      if (investment.contracts && investment.contracts.length > 0) {
        fileUrl = `${process.env.REACT_APP_API_BASE_URL}/documents/contracts/${investment.id}/${investment.contracts[0].filename}`;
      }
      return (
        <tr key={investment.id}>
          <td>{investment.folioId}</td>
          <td>{investment.amount}</td>
          <td>{investment.gat}</td>
          <td>{investment.endDate}</td>
          <td style={{ whiteSpace: 'nowrap', width: '2%', textAlign: 'center' }}>
            {fileUrl ? (
              <Button variant="link" onClick={(e) => handleOpenDocument(fileUrl, e)}>
                <FileEarmark size={25} color={'green'} />
              </Button>
            ) : (
              <label>-</label>
            )}
          </td>
          <td style={{ whiteSpace: 'nowrap', width: '2%', textAlign: 'center' }}>
            <Button variant="outline-primary" onClick={() => handleEditClick(investment.id)}>
              <PencilSquare size={20} />
            </Button>
          </td>
        </tr>
      );
    });
  };

  return (
    <Container>
      <Container>
        <Row className="mb-4 form-title">
          <Col md={6} className="d-flex align-items-center">
            <GraphUpArrow size={18} className="me-2" />
            <h4>Inversiones</h4>
          </Col>
          <Col className="actions">
            <Button size="sm" variant="primary" onClick={() => handleCreateNew()}>
              + Agregar
            </Button>
          </Col>
        </Row>
        <Row className="mb-3 mt-5">
          <Table responsive striped bordered hover>
            <thead>
              <tr>
                <th>Folio</th>
                <th>Monto de Inversión</th>
                <th>GAT</th>
                <th>Fecha de termino</th>
                <th>Contrato</th>
                <th></th>
              </tr>
            </thead>
            <tbody>{renderInvestments()}</tbody>
          </Table>
        </Row>
      </Container>
      {isInvestmentModalOpen && (
        <CustomerInvestmentModal
          isOpen={isInvestmentModalOpen}
          onClose={() => setIsInvestmentModalOpen(false)}
          onSuccess={(response) => handleSuccess(response)}
          title={investmentSelected ? 'Editar inversión' : 'Agregar inversión'}
          userId={userId}
          investmentSelected={investmentSelected}
        />
      )}
      {isDocumentModalOpen && fileBlob && (
        <FileViewerModal
          isOpen={isDocumentModalOpen}
          file={fileBlob}
          handleCloseModal={() => setIsDocumentModalOpen(false)}
        />
      )}
    </Container>
  );
};
export default CustomerInvestments;
